<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke="#00B9FF" stroke-width="1.5"/>
    <path d="M12 7V12L15 14" stroke="#00B9FF" stroke-width="1.5" stroke-linecap="round"/>
    <circle cx="12" cy="12" r="2" stroke="#00B9FF" stroke-width="1.5"/>
  </svg>
</template>

<script>
export default {
  name: 'IconFuture'
}
</script>
